import React, { useCallback } from "react";
import PropTypes from "prop-types";
import { DndProvider } from "react-dnd-cjs";
import HTML5Backend from "react-dnd-html5-backend-cjs";
import DragDropItem from "./DragDropItem.js";
import DragDropItemTypes from "./DragDropItemTypes";

/**
 * adapted/genericized from
 * https://react-dnd.github.io/react-dnd/examples/sortable/simple
 */
export default function DragDropList({
  items,
  onReorder,
  itemType,
  renderItem,
  getItemId = item => item,
}) {
  const moveItem = useCallback(
    (dragIndex, hoverIndex) => {
      const item = items[dragIndex];
      const itemsCopy = [...items];
      itemsCopy.splice(dragIndex, 1);
      itemsCopy.splice(hoverIndex, 0, item);
      onReorder(itemsCopy);
    },
    [items]
  );

  return (
    <DndProvider backend={HTML5Backend}>
      {items.map((item, index) => (
        <DragDropItem
          key={getItemId(item)}
          index={index}
          itemId={getItemId(item)}
          moveItem={moveItem}
          itemType={itemType}
        >
          {renderItem(item, index)}
        </DragDropItem>
      ))}
    </DndProvider>
  );
}

DragDropList.propTypes = {
  items: PropTypes.array.isRequired,
  onReorder: PropTypes.func.isRequired,
  renderItem: PropTypes.func.isRequired,
  itemType: PropTypes.oneOf(Object.values(DragDropItemTypes)).isRequired,
  getItemId: PropTypes.func,
};
